import { createContext } from 'react';
import { IFileData, ICreateUpdateFirmware, TFirmwareType } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';
export interface IInitialFormData {
	typeSelectedFirmware: TFirmwareType;
	nameOfFirmware: string;
	versionOfFirmware: string;
	description: string;
	fileData: IFileData;
}

export interface IEditFirmwareState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	id: string;
	typeSelectedFirmware: Nullable<TFirmwareType>;
	nameOfFirmware: string;
	versionOfFirmware: string;
	description: string;
	fileData: IFileData;
	dataForSubmit: ICreateUpdateFirmware | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editFirmwareInitialState: IEditFirmwareState = {
	needRefetchData: false,
	initialFormData: null,
	id: '',
	typeSelectedFirmware: null,
	nameOfFirmware: '',
	versionOfFirmware: '',
	description: '',
	fileData: {
		fileId: '',
		fileHash: null,
		fileName: null,
	},
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditFirmwareContext extends IEditFirmwareState {
	refetchData(value: boolean): void;
	setTypeSelectedFirmware(value: TFirmwareType): void;
	changeNameOfFirmware(value: string): void;
	changeVersionOfFirmware(value: string): void;
	changeDescription(value: string): void;
	changeFileData(value: IFileData): void;
	setDataForSubmit(value: ICreateUpdateFirmware | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const EditFirmwareContext = createContext<IEditFirmwareContext>({
	refetchData: () => undefined,
	setTypeSelectedFirmware: () => undefined,
	changeNameOfFirmware: () => undefined,
	changeVersionOfFirmware: () => undefined,
	changeDescription: () => undefined,
	changeFileData: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editFirmwareInitialState,
});
